// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"46944b57","753":"802f2093","765":"48419a05"}[chunkId] + ".css";
};